function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H30V30H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M24399.357-5479.085a.417.417 0 0 1-.336-.25.406.406 0 0 1 .086-.417l11.652-12.926 5.574-6.174a.4.4 0 0 1 .582-.041l1.914 1.709c.084.043.127.169.168.294a.452.452 0 0 1-.125.292l-5.326 5.88 1.578 1.458a.372.372 0 0 1 .127.292.434.434 0 0 1-.127.291l-4.908 5.421a12.656 12.656 0 0 1-4.576 3.255h5.66a.393.393 0 0 1 .414.417.394.394 0 0 1-.414.417h-8.533a11.586 11.586 0 0 1-2.082.166c-.455.001-.912-.043-1.328-.084zm16.146-.082a.4.4 0 0 1-.418-.417.394.394 0 0 1 .418-.417h1.037a.418.418 0 0 1 .418.417.4.4 0 0 1-.418.417zm-2.459 0a.4.4 0 0 1-.416-.417.393.393 0 0 1 .416-.417h1.043a.394.394 0 0 1 .416.417.4.4 0 0 1-.416.417z",
  transform: "translate(-24393.996 5504.001)"
});

function SvgIconProcedures2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcedures2);
export default __webpack_public_path__ + "static/media/icon_procedures (2).0f855a99.svg";
export { ForwardRef as ReactComponent };